<template>
    <section class="bg-white container-global q-py-xl">
        <div class="">
            <div class="header_section">
                <span class="header_section-sub-title">
                    تقيمات عامة 
                </span>
                <h3 class="header_section-title">
                    مواقع مختارة من التقييم العام 
                </h3>
                <p class="header_section-description">
                    تم تقييمهـا بأداة أكواد من مستخدمين فعليين 
                </p>
            </div>
            <div class="col-12 row q-col-gutter-lg">
                <template v-if="statisticsLoader">
                    <div class="col-12 col-sm-6 col-md relative-position" v-for="(i, index) in Array(5)"
                        :key="index">
                        <div class="q-pa-sm q-card--bordered column items-end" v-if="index < 5" :title="i">
                            <q-skeleton height="165px" width="100%" animation="fade" />
                            <q-skeleton type="QBadge" class="q-mt-sm" animation="fade" width="100px" />
                            <q-skeleton type="QChip" class="q-mt-sm" animation="fade" width="140px" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-12 col-sm-6 col-md relative-position"
                        v-for="(item, index) in homeStatsData?.random_top_websites" :key="index">
                        <div class="q-pa-sm q-card--bordered">
                            <div @click.prevent="goTo(item?.url)" role="link"
                                class="site_url akwad-medium cursor-pointer text-body1 text-dark">

                                <q-img :src="getResponsiveImageUrl(item?.image)" style="min-height: 165px"
                                    class="rounded-borders" fit="cover" :width="lteThanSixFiveZero
                                        ? '100%'
                                        : lteThanOneZeroTwoFour
                                            ? '60%'
                                            : '100% '" spinner-color="primary" loading="lazy"
                                    alt="website-image" />
                                <div class="row items-center q-mt-sm justify-end">
                                    {{ item?.url ? item?.url : 'No Url' }}
                                </div>
                            </div>
                            <div class="rating_value--container row justify-end items-center">
                                <div class="value flex flex-center">
                                    <q-rating v-model="item.average_rate" icon-half="icon-star-half" readonly
                                        color="yellow" size="xs" />
                                    <span class="akwad-bold text-h6 q-ml-sm">{{
                                        item.average_rate
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import { useLoaderStore } from '@/stores/loader';
import type { ISiteCards } from '@/types/ISiteCards';
import { APP_BASE_URL } from '@/boot/axios';

// Props
const props = defineProps<{
    homeStatsData?: ISiteCards;
    statisticsLoader: boolean;
}>();

const router = useRouter();
const $q = useQuasar();
const akwadLoader = useLoaderStore();

const lteThanOneZeroTwoFour = computed(() => $q.screen.width < 1024);
const lteThanSixFiveZero = computed(() => $q.screen.width <= 650);

const goTo = (url: string) => {
    akwadLoader.show();
    router.push(`/result/${url}?page=1`);
};

const getResponsiveImageUrl = (imagePath?: string): string => {
    if (!imagePath) return '/website-dummy.jpg';

    const lastDotIndex = imagePath.lastIndexOf('.');
    const basePath = imagePath.slice(0, lastDotIndex);
    const extension = imagePath.slice(lastDotIndex);
    const suffix = '_thumb';

    return `${APP_BASE_URL}/${basePath}${suffix}${extension}`;
};
</script>

<style scoped lang="scss">


.site_url {
    transition: all 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
}

.rating_value--container {
    padding: 12px 8px;
    
    .value {
        gap: 8px;
    }
}

/* Responsive */
</style>